import React from 'react';
import styles from './resources.module.scss';
import { useTranslation } from 'next-i18next';
import mainStyles from '../../../pages/investors/investors.module.scss';
import { combineCN } from '@helpers/styles.helper';
import { environment } from '@environment';

const IR_EMAIL = 'anghami@apcoworldwide.com';

const InvestorsResourcesSection = () => {
	const { t } = useTranslation();

	return (
		<section id="investors-resources" className={mainStyles.main_section_wrapper}>
			<h2 className={mainStyles.title}>{t('investor_relations_investor_resources')}</h2>
			<div className={combineCN(styles.content_wrapper, 'd-flex f-justify-center')}>
				<a
					href={`mailto:${IR_EMAIL}?subject=Investor%20relations`}
					className={combineCN(styles.resource_item, 'd-flex f-center')}
				>
					<img
						src={`${environment.new_web_cdn_url}/new/investors/email.svg`}
						alt="Contact IR"
						className={styles.icon}
					/>
					<div className={styles.label}>{t('investor_relations_contact_ir')}</div>
				</a>
				<div className={combineCN(styles.resource_item, styles.disabled, 'd-flex f-center')}>
					<div className={styles.badge}>{t('coming_soon_badge')}</div>
					<img
						src={`${environment.new_web_cdn_url}/new/investors/corporate-presentation.svg`}
						alt="Corporate Presentation"
						className={styles.icon}
					/>
					<div className={styles.label}>{t('investor_relations_corporate_presentation')}</div>
				</div>
			</div>
		</section>
	);
};

export default InvestorsResourcesSection;
